import { useEffect, useState } from "react";
import { blogs } from './MockData'
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { useFindBlogBySearchMutation } from "../../redux/services/blogsApi";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { getBlogTotalPages, setblogs } from "../../redux/slices/blogsSlice";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { IoMdArrowRoundBack } from "react-icons/io";
import Loading from "../commons/Loading";
import { HashLink as Link } from "react-router-hash-link";
import Footer from "../../components/Footer/Footer";
import { AiOutlineArrowRight } from "react-icons/ai";

function ViewAllDetail() {
  const [blog, setBlog] = useState([]); // Initial state
  const navigate = useNavigate();
  const [findBlogBySearch, findBlogBySearchResponse] = useFindBlogBySearchMutation() as any;
  const [page, setPage] = useState(0) as any;
  const [offset, setOffset] = useState(6);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;
  const totalPageRecord = useAppSelector(getBlogTotalPages);
  const dispatch: any = useAppDispatch();

  const getBlogDetailByPagination = async (
    reqOffset: number,
    reqPage: number
  ) => {
    await findBlogBySearch({
      payload: {
        offset: reqOffset,
        page: reqPage,
        orderBy: "asc",
        status: true,
      },
    });
  };

  useEffect(() => {
    findBlogBySearch({
      payload: {
        offset: offset,
        page: page,
        orderBy: "asc",
        status: true,
      },
    });
  }, [findBlogBySearch]);

  useEffect(() => {
    if (findBlogBySearchResponse.isSuccess) {
      let userFindBlogBySearchResponse: any = findBlogBySearchResponse.data;
      // Update the blog state with new data
      dispatch(setblogs(userFindBlogBySearchResponse.data));
      setBlog(userFindBlogBySearchResponse.data); // Update blog state directly with the new fetched blogs
    }
  }, [findBlogBySearchResponse.isSuccess]);

  const handleLoadNext = () => {
    setPage(page + 1);
    getBlogDetailByPagination(offset, page + 1);
  };

  const handleLoadPrev = () => {
    setPage(page - 1);
    getBlogDetailByPagination(offset, page - 1);
  };

  return (
    <div>
      <div className="h-[75px] z-10 fixed mx-10 ">
        <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
      </div>
      {findBlogBySearchResponse.isLoading ? <Loading /> : null}
      <div className="my-[40px] md:mx-[13px] lg:mx-[50px] pt-[20px]">
        <div
          style={{
            marginLeft: "15px",
            marginRight: "15px ",
            marginTop: "100px",
            marginBottom: "50px",
          }}
        >
          <Link to="/#latest-news">
            <IoMdArrowRoundBack className="md:text-[40px] text-[30px] cursor-pointer" />
          </Link>

          <div className="w-full p-1  lg:h-[410px]">
            <img
              src={require("../../assets/blogs.jpg")}
              alt="Latest News"
              className="block object-cover object-center w-full h-full rounded-lg"
            />
          </div>

          <p className="mt-6 font-bold lg:text-2xl text-2xl text-[#3B3A40] mx-[10px]">
            Latest News
          </p>
        </div>

        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {blog.map((post: any, index: any) => (
              <Grid item xs={4} sm={4} md={4} key={index}>
                <Card
                  sx={{
                    width: "w-full",
                    height: "450px",
                    borderRadius: "10px",
                    border: "1px solid #e6e6e6",
                    boxShadow: "none",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                    marginTop: "30px",
                    marginLeft: "15px",
                    marginRight: "15px",
                  }}
                  onClick={() => {
                    navigate("/find-blog", {
                      state: {
                        image: post.img,
                        title: post.title,
                        description: post.description,
                        id: post.id,
                      },
                    });
                  }}
                >
                  <CardMedia
                    component="img"
                    height="100%"
                    width="100%"
                    sx={{
                      height: 200,
                      width: 1100,
                    }}
                    // Use imageUrl from API response for displaying the image
                    image={post.imageUrl || post.img}
                    alt="parking"
                  />
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      height: "100%",
                      width: "100%",
                      padding: "0",
                      margin: "0",
                      borderRadius: "0",
                      border: "0",
                    }}
                  >
                    <Tooltip
                      title={post.title}
                      placement="bottom-end"
                      className=" text-left"
                    >
                      <h2
                        style={{ overflowWrap: "break-word" }}
                        className="text-[#2D3748] mx-2 lg:text-[22px] md:text-[1.4rem] text-[1.0rem] font-semibold truncate  w-[90%] mt-5"
                      >
                        {post.title}
                      </h2>
                    </Tooltip>
                    <h1 className="text-[#667085] mx-2 font-normal w-100%  mt-5">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: post.description.slice(0, 140),
                        }}
                      />
                      {post.description.length > 50 ? (
                        <div className="flex flex-row">
                          <span
                            className="text-[#E23744]"
                            onClick={() => {
                              navigate("/find-latestNews", {
                                state: {
                                  image: post.imageUrl,
                                  title: post.title,
                                  description: post.description,
                                  id: post.id,
                                },
                              });
                            }}
                          >
                            {"Learn more"}
                          </span>
                          <div className="mt-1 ml-1 text-[#E23744]">
                            <AiOutlineArrowRight />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </h1>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
        {blog && blog.length === 0 ? (
          ""
        ) : (
          <div className="flex gap-6 justify-center mt-5 mb-5">
            <button
              onClick={() => {
                handleLoadPrev();
              }}
              disabled={page == 0 ? true : false}
              className={`p-3 rounded-[8px] flex items-center ${page == 0
                ? "bg-slate-300 text-black"
                : "text-white bg-[#E23744] hover:bg-red-700 "
                }`}
            >
              <BiChevronLeft />
              Previous{" "}
            </button>
            <button
              onClick={() => {
                handleLoadNext();
              }}
              disabled={page + 1 == totalPageRecord ? true : false}
              className={`p-3 flex items-center text-center rounded-[8px] ${page + 1 == totalPageRecord
                ? "bg-slate-300 text-black"
                : "text-white bg-[#E23744] hover:bg-red-700 "
                }`}
            >
              &nbsp;Next
              <BiChevronRight className="mr-4" />
            </button>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default ViewAllDetail;